import styles from './PlayerList.module.css'
import { useState, lazy, Suspense } from 'react'
import { useLanguage } from '@context/LanguageContext'
import AvatarSelector from '../avatars/AvatarSelector'
import { DeleteIcon } from '@components/interface/Icons'

const DeletePlayerDialog = lazy(() => import('../dialogs/DeletePlayerDialog'))

function PlayerList ({
  players,
  selectingAvatarFor,
  setSelectingAvatarFor,
  onAvatarChange,
  onDeletePlayer
}) {
  const { t } = useLanguage()
  const [playerToDelete, setPlayerToDelete] = useState(null)

  const handleDeleteClick = (player) => {
    setPlayerToDelete(player)
  }

  const handleConfirmDelete = () => {
    if (playerToDelete) {
      onDeletePlayer(playerToDelete.id)
      setPlayerToDelete(null)
    }
  }

  const handleCancelDelete = () => {
    setPlayerToDelete(null)
  }

  return (
    <>
      <ul
        className={styles.playerList}
        role='list'
        aria-label={t.shared.access.player.list}
      >
        {players.map((player) => (
          <li
            key={player.id}
            className={styles.item}
            role='listitem'
          >
            <span
              id={`player-name-${player.id}`}
              className={styles.name}
            >
              {player.name}
            </span>
            <AvatarSelector
              currentAvatar={player.avatar}
              onSelect={(filename) =>
                onAvatarChange(player.id, filename)}
              labelledById={`player-name-${player.id}`}
              isOpen={selectingAvatarFor === player.id}
              onOpen={() => setSelectingAvatarFor(player.id)}
              onClose={() => setSelectingAvatarFor(null)}
            />

            <button
              type='button'
              className={styles.removeButton}
              onClick={() => handleDeleteClick(player)}
              aria-label={t.shared.access.player.remove.replace('{name}', player.name)}
              title={t.shared.access.player.remove.replace('{name}', player.name)}
            >
              <DeleteIcon size={30} stroke={1.5} aria-hidden='true' />
              <span className='sr-only'>{t.shared.access.player.remove.replace('{name}', player.name)}</span>
            </button>
          </li>
        ))}
      </ul>

      {playerToDelete && (
        <Suspense fallback={null}>
          <DeletePlayerDialog
            player={playerToDelete}
            onConfirm={handleConfirmDelete}
            onCancel={handleCancelDelete}
          />
        </Suspense>
      )}
    </>
  )
}

export default PlayerList
